module.exports = __webpack_public_path__ + "static/img/QRcode1.490e40a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/QRcode1.png
// module id = 1hdw
// module chunks = 0